import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { setOrdersAsViewed } from "services"
import { resetNotViewedOrders } from "@redux"
import classes from "./OrdersSetAsViewedButton.module.scss"
import clsx from "clsx"

const OrdersSetAsViewedButton = (props) => {
  const { orderStatus, setOrders } = props

  const [t, i18n] = useTranslation()

  const notViewedOrders =
    useSelector(state =>
      state.notViewedOrders.notViewedOrders
    )

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)

  const handleReadAll = async () => {
    setSending(true)
    try {
      await setOrdersAsViewed({ orderStatus })

      setOrders(prev =>
        prev.map(order =>
          order.orderStatus === orderStatus
            ? { ...order, isViewed: true }
            : order
        )
      )

      dispatch(
        resetNotViewedOrders(orderStatus)
      )
    } catch (err) {
      console.log(err)
    }
    setSending(false)
  }

  const total =
    notViewedOrders[orderStatus]

  const isLtr = i18n.dir(i18n.language)

  if (total === 0) return null

  return (
    <Button
      color="info"
      loading={sending}
      onClick={handleReadAll}
      className={clsx(classes["button"], isLtr && classes["button-ltr"])}
    >
      {t("همه_را_دیدم")}
    </Button>
  )
}

export default OrdersSetAsViewedButton